import React from 'react';
import { Button } from 'antd';
import { closeManageSubscriptionModal } from 'utils/globalLayerControl';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';

const PracticePaymentBanner = (props: { isFinish?: boolean }) => {
    const navigate = useNavigate();
    if (props?.isFinish) {
        return (
            <div className={s.wrapper}>
                <div className={s.title}>Manage your practice and payment setup</div>
                <div className="mb-6">Review or complete your setup to start receiving patient payments. Fill out your appointment billing policies, consent forms, practice profile, business information, and payout account — all in one place.</div>
                <div>
                    <Button
                        type="primary"
                        onClick={() => {
                            navigate(`${PATH.PAYMENT_SETUP}`);
                            closeManageSubscriptionModal();
                        }}
                    >Manage
                    </Button>
                </div>
                {/* <div className={s.tips}>
                    To update your payment frequency, please complete our <a href='https://docs.google.com/forms/d/e/1FAIpQLSfL4UsO2JFiDrc5BBi2p_Hg-HJD2uopaKzXSA_UNQTTweYM_Q/viewform' target="_blank"> payment update form</a>. Our team will assist you shortly.
                </div> */}
            </div>
        );
    }
    return (
        <div className={s.wrapper}>
            <div className={s.title}>Manage your practice and payment setup</div>
            <div className="mb-6">Review or complete your setup to start receiving patient payments. Fill out your appointment billing policies, consent forms, practice profile, business information, and payout account — all in one place.</div>
            <Button
                type="primary"
                onClick={() => {
                    navigate(`${PATH.PAYMENT_SETUP}`);
                    closeManageSubscriptionModal();
                }}
            >Set up now
            </Button>
        </div>
    );
};

export default PracticePaymentBanner;
